import { differenceInCalendarDays, isToday, isYesterday } from 'date-fns';
import { useTranslation } from 'react-i18next';

export const useFormatChatDayDividerLabel = (timestamp: Date) => {
  const { t } = useTranslation(['translationReactComponents']);
  const compareDate = new Date();

  if (isToday(timestamp)) {
    return t('Today');
  }

  if (isYesterday(timestamp)) {
    return t('Yesterday');
  }

  const daysAgo = differenceInCalendarDays(compareDate, timestamp);

  if (daysAgo >= 0 && daysAgo < 7) {
    return t('dateFormats.dayLong', { date: timestamp });
  }

  return t('dateFormats.shortMonthDayYear', { date: timestamp });
};
